module.exports = __webpack_public_path__ + "img/wzarticcove_sample.25da53fe.png";